import React from "react";
import CardSimple from "../../../../components/basic/CardSimple";

const User = () => {
  return (
    <div id="add-employee">
      <br />
      <div>
        <CardSimple>
          <div className="support-wrapper support-manual">
            <h2>Add an Employee</h2>
            <ul>
              <li>Go to Menu > Users > Employee</li>
              <img src={require("./SupportDocImages/users_images/users.PNG")} />
              <li>Click the Add button, located on the right of the screen</li>
              <img src="http://techpos.ca/support-images/User/Employee/add/AddEmp-2.png" />
              <li>
                Fill out the profile information and select a role for the
                employee
              </li>
              <img src="http://techpos.ca/support-images/User/Employee/add/AddEmp-3.png" />
              <p>
                <strong>NOTE:</strong> Employees <b>CAN'T</b> be underage. Each
                role provides the employee with different access privileges. For
                more information, please refer to the section titled Employee's
                Role Access.
              </p>
              <li>Fill out the contact information</li>
              <img src="http://techpos.ca/support-images/User/Employee/add/AddEmp-4.png" />
              <p>
                <strong>NOTE:</strong> the email address must be unique to each
                employee as this will become the employee's login username
              </p>
              <li>
                Under login info, please provide the employee with a password
              </li>
              <img
                src="http://techpos.ca/support-images/User/Employee/add/AddEmp-6.png"
                width="800"
              />
              <p>
                <strong>NOTE:</strong> The password should be at least 8
                characters, contain at least 1 uppercase letter, 1 lowercase
                letter, a symbol and a number.{" "}
              </p>
              <li>Select which branches the employee has access to</li>
              <img src="http://techpos.ca/support-images/User/Employee/add/AddEmp-5.png" />
              <li>Click on Save</li>
              <li>
                Your employee will receive an email with their new credentials,
                including password. They will then be able to log into the
                system.
              </li>
              {/* <img src="http://techpos.ca/support-images/User/Employee/add/AddEmp-7.png" /> */}
            </ul>
          </div>
        </CardSimple>
      </div>
      <div id="edit-employee">
        <br />
        <CardSimple>
          <div className="support-wrapper support-manual">
            <h2>Edit an Employee</h2>
            <ul>
              <li>Go to Menu > Users > Employee</li>
              <img src={require("./SupportDocImages/users_images/users.PNG")} />
              <li>
                In the employee table, look for the employee you want to edit
              </li>
              <img src="http://techpos.ca/support-images/User/Employee/edit/EditEmp-4.png" />
              <li>Click on the Edit Icon</li>
              <img src="http://techpos.ca/support-images/User/Employee/edit/EditEmp-3.png" />
              <li>Edit the information for the employee</li>
              <li>Click on Save</li>
              <p>
              <strong>NOTE:</strong> Email can be edited only at the moment of employee
                creation. Only employees with an active status can access
                TechPOS, therefore changing the status from Active to Inactive
                restricts employee access to the system.
              </p>
            </ul>
          </div>
        </CardSimple>
      </div>
      <div id="add-patient">
        <br />
        <CardSimple>
          <div className="support-wrapper support-manual">
            <h2>Add a Member</h2>
            <ul>
              <li>Go to Menu > Users > Member</li>
              <img src="http://techpos.ca/support-images/User/Member/add/MemberAdd-1.png" />
              <li>Click the Add button, located on the right of the screen</li>
              <img src="http://techpos.ca/support-images/User/Member/add/MemberAdd-3.png" />
              <li>Attach a photo of the member</li>
              <img src="http://techpos.ca/support-images/User/Member/add/MemberAdd-2.png" />
              <p>
              <strong>NOTE:</strong> The photo should be of the member, but it can be anything
              </p>
              <li>Fill the general information</li>
              <img src="http://techpos.ca/support-images/User/Member/add/MemberAdd-4.png" />
              <p>
                <b>NOTE: No underage members allowed</b>
              </p>
              <li>
                Fill the contact information, add notes if applicable. CLick on
                Save
              </li>
              <img src="http://techpos.ca/support-images/User/Member/add/MemberAdd-5.png" />
              <br />
              <img
                src="http://techpos.ca/support-images/User/Member/add/MemberAdd-6.png"
                width="639"
              />
            </ul>
          </div>
        </CardSimple>
      </div>
      <div id="edit-patient">
        <br />
        <CardSimple>
          <div className="support-wrapper support-manual">
            <h2>Edit a Member</h2>
            <ul>
              <li>Go to Menu > Users > Member</li>
              <img src="http://techpos.ca/support-images/User/Member/add/MemberAdd-1.png" />
              <li>Search for the member you want to edit</li>
              <li>Click on Edit button</li>
              <li>Edit the information for the member</li>
              <p>
              <strong>NOTE:</strong> A member has special discounts and access to certain
                user-defined campaigns. Inactivating a Member removes the
                possibility of selling something to that member.
              </p>
            </ul>
          </div>
        </CardSimple>
      </div>
      <div id="role-access">
        <br />
        <CardSimple>
          <div className="support-wrapper support-manual">
            <h2>Role Access</h2>

            <h3>Store Owner</h3>
            <ul>
              <li>Access to all the features of TechPOS + Reports</li>
            </ul>

            <h3>Store Manager</h3>
            <ul>
              <li>Access to all the features of TechPOS</li>
            </ul>

            <h3>Inventory Manager</h3>
            <ul>
              <li>User: Member, Doctor, Vendor</li>
              <li>
                Inventory: Products Catalog, Product Categories, PO, Warehouse
              </li>
              <li>Pricing: Measurement Settings, Campaign, Price Setting</li>
              <li>Preferences: Device</li>
              <li>Admin: Cash Register, Shifts, Orders, Setting</li>
              <li>POS Sales</li>
            </ul>

            <h3>Assistant Manager</h3>
            <ul>
              <li>User: Member</li>
              <li>Inventory: Products Catalog</li>
              <li>Admin: Cash Register</li>
              <li>POS Sales</li>
            </ul>

            <h3>Sales Person</h3>
            <ul>
              <li>User: Member</li>
              <li>POS Sales</li>
            </ul>
          </div>
        </CardSimple>
      </div>
    </div>
  );
};

export default User;
